import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetUncategorizedEmailSequenceTemplates as GetUncategorizedEmailTemplatesQuery,
    GetUncategorizedEmailSequenceTemplatesVariables as GetUncategorizedEmailTemplatesQueryVariables,
    EmailSequenceTemplateFullFragment,
} from 'nutshell-graphql-types';

import GET_UNCATEGORIZED_EMAIL_SEQUENCE_TEMPLATES from '../queries/get-uncategorized-email-sequence-templates.graphql';

export const useGetUncategorizedEmailTemplates = ({
    search,
    creatorIds,
    onlyArchived,
    includeShared,
    includeUnsharedFromOthers,
}: {
    search?: string;
    creatorIds?: string[];
    onlyArchived?: boolean;
    includeShared?: boolean;
    includeUnsharedFromOthers?: boolean;
}): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    emailSequenceTemplates: EmailSequenceTemplateFullFragment[];
} => {
    const {loading, data, error} = useQuery<
        GetUncategorizedEmailTemplatesQuery,
        GetUncategorizedEmailTemplatesQueryVariables
    >(GET_UNCATEGORIZED_EMAIL_SEQUENCE_TEMPLATES, {
        variables: {
            creatorIds,
            search,
            onlyArchived,
            includeShared,
            includeUnsharedFromOthers,
        },
        notifyOnNetworkStatusChange: true,
    });

    const emailSequenceTemplateGroups = data ? data.emailSequenceTemplateGroups : null;

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        emailSequenceTemplates: emailSequenceTemplateGroups
            ? emailSequenceTemplateGroups.uncategorized
            : [],
    };
};
